/**
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

jQuery.cookie = function (b, j, m) { if (typeof j != "undefined") { m = m || {}; if (j === null) { j = ""; m.expires = -1 } var e = ""; if (m.expires && (typeof m.expires == "number" || m.expires.toUTCString)) { var f; if (typeof m.expires == "number") { f = new Date(); f.setTime(f.getTime() + (m.expires * 24 * 60 * 60 * 1000)) } else { f = m.expires } e = "; expires=" + f.toUTCString() } var l = m.path ? "; path=" + (m.path) : ""; var g = m.domain ? "; domain=" + (m.domain) : ""; var a = m.secure ? "; secure" : ""; document.cookie = [b, "=", encodeURIComponent(j), e, l, g, a].join("") } else { var d = null; if (document.cookie && document.cookie != "") { var k = document.cookie.split(";"); for (var h = 0; h < k.length; h++) { var c = jQuery.trim(k[h]); if (c.substring(0, b.length + 1) == (b + "=")) { d = decodeURIComponent(c.substring(b.length + 1)); break } } } return d } };

/**
 * Module to show Recently Viewed Products
 *
 * Copyright (c) 2014 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

Shopify.Products = (function () {
    var config = {
        howManyToShow: 3,
        howManyToStoreInMemory: 10,
        wrapperId: 'recently-viewed-products',
        templateId: 'recently-viewed-product-template',
        layout: 'slider',
        swipe: true,
        media: 'adapt',
        onComplete: null
    };
    var productHandleQueue = [];
    var wrapper = null;
    var template = null;
    var shown = 0;
    var shownSection = 0;
    var cookie = {
        configuration: {
            expires: 90,
            path: '/',
            domain: window.location.hostname
        },
        name: 'shopify_recently_viewed',
        write: function (recentlyViewed) {
            jQuery.cookie(this.name, recentlyViewed.join(' '), this.configuration);
            localStorage.setItem(this.name, recentlyViewed.join(' '), this.configuration);
        },
        read: function () {
            var recentlyViewed = [];
            var cookieValue = jQuery.cookie(this.name);
            var localStorageValue = localStorage.getItem('shopify_recently_viewed');
            
            // TEST: Inject a bogus product handle for testing invalid URL handling
            // Remove this block after testing is complete
            // var existingValue = cookieValue || localStorageValue || '';
            // if (existingValue && existingValue.indexOf('bogus-test-product-does-not-exist') === -1) {
            //     existingValue = 'bogus-test-product-does-not-exist ' + existingValue;
            //     jQuery.cookie(this.name, existingValue, this.configuration);
            //     localStorage.setItem(this.name, existingValue);
            //     cookieValue = existingValue;
            //     console.log('TEST: Injected bogus product handle for testing. New value:', existingValue);
            // }
            // END TEST BLOCK
            
            //console.log('shopify_recently_viewed cookie value:', cookieValue);
            //console.log('shopify_recently_viewed localStorage value:', localStorageValue);
            
            if (Shopify.designMode && !cookieValue) {
                cookieValue = localStorageValue;
            }
            if (cookieValue !== null) {
                recentlyViewed = cookieValue.split(' ').filter(function(handle) {
                    return handle && handle.trim() !== '';
                });
            }
            //console.log('Filtered recently viewed handles:', recentlyViewed);
            return recentlyViewed;
        },
        destroy: function () {
            jQuery.cookie(this.name, null, this.configuration);
        },
        remove: function (productHandle) {
            var recentlyViewed = this.read();
            //console.log('Attempting to remove handle:', productHandle);
            //console.log('Current recently viewed list:', recentlyViewed);
            
            var position = jQuery.inArray(productHandle, recentlyViewed);
            //console.log('Position found:', position);
            
            if (position !== -1) {
                recentlyViewed.splice(position, 1);
                this.write(recentlyViewed);
                //console.log('Successfully removed. New list:', recentlyViewed);
            } else {
                //console.log('Product handle not found in recently viewed list');
            }
        }
    };

    var finalize = function () {
        var items = wrapper.find('.item')
        if (items.length <= 2) $('#recently-viewed-products-list').addClass('center');

        $('#recently-viewed-products-list-2').addClass('recently-viewed-loaded');

        wrapper.show();
        // If we have a callback.
        if (config.onComplete) {
            try {
                config.onComplete();
            } catch (error) { }
        }
    };

    var moveAlong = function (wrapperP) {
        if (productHandleQueue.length && shown < config.howManyToShow) {
            var url = window.routes.root + '/products/' + productHandleQueue[shown] + '?view=ajax_recently_viewed';

            jQuery.ajax({
                type: 'get',
                url: url,
                cache: false,
                success: function (product, textStatus, jqXHR) {
                    // Check if the response is a valid product (not a redirect to any other page)
                    // If product was redirected, the response won't contain product-specific elements
                    var $tempProduct = $('<div>').html(product);
                    
                    // Check for valid product content - must have product-specific elements
                    var hasProductItem = $tempProduct.find('.product-item').length > 0 || product.indexOf('product-item') !== -1;
                    var hasProductCard = $tempProduct.find('.card').length > 0;
                    var hasProductHandle = $tempProduct.find('[data-product-handle]').length > 0 || product.indexOf('data-product-handle') !== -1;
                    var hasProductLink = $tempProduct.find('a[href*="/products/"]').length > 0;
                    
                    // Must have at least product-item class or product handle attribute (core product card elements)
                    var isValidProduct = hasProductItem || hasProductHandle;
                    
                    // Check if response contains indicators of non-product pages (redirects)
                    // This catches redirects to homepage, collections, pages, blogs, cart, etc.
                    var hasNonProductPageIndicators = 
                        product.indexOf('template-index') !== -1 ||           // Homepage
                        product.indexOf('template-collection') !== -1 ||      // Collection
                        product.indexOf('template-page') !== -1 ||            // Regular page
                        product.indexOf('template-blog') !== -1 ||            // Blog
                        product.indexOf('template-article') !== -1 ||         // Article
                        product.indexOf('template-cart') !== -1 ||            // Cart
                        product.indexOf('template-404') !== -1 ||             // 404 page
                        product.indexOf('template-search') !== -1 ||          // Search
                        product.indexOf('shopify-section-template--') !== -1 || // Section template indicators
                        $tempProduct.find('[class*="template-index"]').length > 0 ||
                        $tempProduct.find('[class*="template-collection"]').length > 0 ||
                        $tempProduct.find('[class*="template-page"]').length > 0;
                    
                    // Also check if response is too large (likely a full page instead of a product card)
                    var isTooLarge = product.length > 50000; // Product cards should be much smaller than this
                    
                    // Also check if response is empty or too small to be valid
                    var isTooSmall = product.trim().length < 100;
                    
                    if (isValidProduct && !hasNonProductPageIndicators && !isTooLarge && !isTooSmall) {
                        wrapperP.append(product);
                        shown++;
                        moveAlong(wrapperP);
                    } else {
                        // Invalid product - remove from cookie and continue
                        console.log('Invalid product detected (redirect or empty), removing:', productHandleQueue[shown]);
                        cookie.remove(productHandleQueue[shown]);
                        shown++;
                        moveAlong(wrapperP);
                    }
                },
                error: function () {
                    cookie.remove(productHandleQueue[shown]);
                    shown++;
                    moveAlong(wrapperP);
                }
            });
        } else {
            finalize();
        }
    };

    var doAlong = function (wrapperS) {
        const recentlyViewed = wrapperS.parents('.halo-recently-viewed-block');

        if (productHandleQueue.length && shownSection < config.howManyToShow) {
            // Skip empty or invalid product handles
            var currentHandle = productHandleQueue[shownSection];
            if (!currentHandle || currentHandle.trim() === '') {
                //console.log('Skipping empty product handle at index:', shownSection);
                shownSection++;
                doAlong(wrapperS);
                return;
            }
            
            var url = window.routes.root + '/products/' + currentHandle + '?view=ajax_recently_viewed';
            
            //console.log('AJAX URL:', url);

            jQuery.ajax({
                type: 'get',
                url: url,
                cache: false,
                dataType: 'html',
                success: function (product) {
                    //console.log('AJAX response length:', product.length);
                    //console.log('AJAX response preview:', product.substring(0, 200));
                    
                    // Create a temporary container to parse the HTML
                    var $tempContainer = $('<div>').html(product);
                    
                    // Check for valid product content - must have product-specific elements
                    var hasProductItem = $tempContainer.find('.product-item').length > 0 || product.indexOf('product-item') !== -1;
                    var hasProductHandle = $tempContainer.find('[data-product-handle]').length > 0 || product.indexOf('data-product-handle') !== -1;
                    
                    // Must have at least product-item class or product handle attribute (core product card elements)
                    var isValidProduct = hasProductItem || hasProductHandle;
                    
                    // Check if response contains indicators of non-product pages (redirects)
                    // This catches redirects to homepage, collections, pages, blogs, cart, etc.
                    var hasNonProductPageIndicators = 
                        product.indexOf('template-index') !== -1 ||           // Homepage
                        product.indexOf('template-collection') !== -1 ||      // Collection
                        product.indexOf('template-page') !== -1 ||            // Regular page
                        product.indexOf('template-blog') !== -1 ||            // Blog
                        product.indexOf('template-article') !== -1 ||         // Article
                        product.indexOf('template-cart') !== -1 ||            // Cart
                        product.indexOf('template-404') !== -1 ||             // 404 page
                        product.indexOf('template-search') !== -1 ||          // Search
                        product.indexOf('shopify-section-template--') !== -1 || // Section template indicators
                        $tempContainer.find('[class*="template-index"]').length > 0 ||
                        $tempContainer.find('[class*="template-collection"]').length > 0 ||
                        $tempContainer.find('[class*="template-page"]').length > 0;
                    
                    // Also check if response is too large (likely a full page instead of a product card)
                    var isTooLarge = product.length > 50000; // Product cards should be much smaller than this
                    
                    // Also check if response is empty or too small to be valid
                    var isTooSmall = product.trim().length < 100;
                    
                    if (!isValidProduct || hasNonProductPageIndicators || isTooLarge || isTooSmall) {
                        // Invalid product - remove from cookie and continue
                        console.log('Invalid product detected (redirect or empty), removing:', currentHandle);
                        cookie.remove(currentHandle);
                        shownSection++;
                        doAlong(wrapperS);
                        return;
                    }
                    
                    // Remove ALL script tags to prevent conflicts
                    $tempContainer.find('script').remove();

                    // Get the cleaned HTML content
                    var cleanedProduct = $tempContainer.html();

                    // The product-card-02 snippet already includes the proper structure
                    // Just wrap it in a product div for the slider
                    var wrappedProduct = '<div class="product">' + cleanedProduct + '</div>';

                    // For slider layout, append to swiper-wrapper instead of swiper container
                    if (config.layout == 'slider') {
                        wrapperS.find('.swiper-wrapper').append(wrappedProduct);
                    } else {
                        wrapperS.append(wrappedProduct);
                    }

                    if (shownSection == 0) {
                        const productLoading = wrapperS.find('.product-item--loadingNoInfo').parents('.product');
                        productLoading.remove();
                    }

                    shownSection++;
                    doAlong(wrapperS);
                },
                error: function () {
                    // Remove the invalid product handle from cookie/localStorage
                    console.log('BEFORE removal - Cookie:', jQuery.cookie('shopify_recently_viewed'));
                    console.log('BEFORE removal - localStorage:', localStorage.getItem('shopify_recently_viewed'));
                    console.log('Removing invalid product handle from storage:', currentHandle);
                    cookie.remove(currentHandle);
                    console.log('AFTER removal - Cookie:', jQuery.cookie('shopify_recently_viewed'));
                    console.log('AFTER removal - localStorage:', localStorage.getItem('shopify_recently_viewed'));
                    shownSection++;
                    doAlong(wrapperS);
                }
            });
        } else {
            if (productHandleQueue.length == 0) {
                recentlyViewed.hide();
                return;
            }

            if (config.layout == 'slider') {
                var productGrid = wrapperS,
                    itemToShow = productGrid.data('item-to-show'),
                    itemDots = productGrid.data('item-dots'),
                    itemDotsMb = productGrid.data('item-dots-mb'),
                    itemArrows = productGrid.data('item-arrows'),
                    itemArrowsMb = productGrid.data('item-arrows-mb');

                if (productGrid.length > 0) {
                    if (!productGrid.hasClass('swiper-initialized')) {
                        productGrid.addClass('swiper-initialized');

                        $('.recentlyViewed-row.products-carousel').attr('data-recent-products-number');

                        var slidesCount;
                        var sliderCounter = $('.recentlyViewed-row.products-carousel');

                        var updateSliderCounter = function(swiper) {
                            var currentSlide = swiper.activeIndex + 1;
                            slidesCount = swiper.slides.length;
                            $(sliderCounter).attr('data-recent-products-number', slidesCount);
                        };

                        // Convert products to swiper slides
                        productGrid.find('.product').each(function() {
                            $(this).addClass('swiper-slide');
                        });

                        var swiperConfig = {
                            slidesPerView: 'auto',
                            spaceBetween: 0,
                            //spaceBetween: 16,
                            loop: false,
                            speed: 600,
                            grabCursor: true,
                            //watchSlidesProgress: true,
                            
                            navigation: {
                                nextEl: '.halo-recently-viewed-block .swiper-button-next',
                                prevEl: '.halo-recently-viewed-block .swiper-button-prev',
                            },
                           
                            on: {
                                init: function() {
                                    updateSliderCounter(this);

                                    if (typeof judgemeWidget !== 'undefined') {
                                        judgemeWidget.init();
                                    }
                                },
                                slideChange: function() {
                                    updateSliderCounter(this);
                                }
                            }
                        };

                        // Add RTL support
                        if (window.rtl_swiper) {
                            swiperConfig.dir = 'rtl';
                        }

                        var swiper = new Swiper(productGrid[0], swiperConfig);

                        // Store swiper instance for later use
                        productGrid[0].swiper = swiper;

                        $checkRecentSlidesNumber = $('.swiper-recently-viewed').attr('data-recent-products-number');
                        console.log("$checkRecentSlidesNumber: " + $checkRecentSlidesNumber);

                        // if ( $checkRecentSlidesNumber == 1 )  {
                        //     // For single product, we could disable loop or handle differently
                        //     swiper.params.loop = false;
                        //     swiper.update();
                        // }

                        // Add clear all button to the slider container
                        if (!recentlyViewed.find('.clear-all-recently-viewed').length) {
                            recentlyViewed.find('.halo-block-header').append('<button class="clear-all-recently-viewed" aria-label="Clear Recently Viewed Products">Clear Recently Viewed</button>');
                        }

                        // Add remove buttons to each product item
                        productGrid.find('.product-item .card').each(function() {
                            if (!$(this).find('.remove-recently-viewed').length) {
                                $(this).prepend('<button class="remove-recently-viewed" aria-label="Remove Recently Viewed Product"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M 38.982422 6.9707031 A 2.0002 2.0002 0 0 0 37.585938 7.5859375 L 24 21.171875 L 10.414062 7.5859375 A 2.0002 2.0002 0 0 0 8.9785156 6.9804688 A 2.0002 2.0002 0 0 0 7.5859375 10.414062 L 21.171875 24 L 7.5859375 37.585938 A 2.0002 2.0002 0 1 0 10.414062 40.414062 L 24 26.828125 L 37.585938 40.414062 A 2.0002 2.0002 0 1 0 40.414062 37.585938 L 26.828125 24 L 40.414062 10.414062 A 2.0002 2.0002 0 0 0 38.982422 6.9707031 z"></path></svg></button>');
                            }
                        });

                        // Function to update remove button visibility - always show remove buttons
                        var updateRemoveButtonVisibility = function() {
                            // Always show remove buttons regardless of count
                            productGrid.find('.remove-recently-viewed').show();
                        };

                        // Initial check for remove button visibility
                        updateRemoveButtonVisibility();

                        // Add click event handler for clear all button
                        recentlyViewed.on('click', '.clear-all-recently-viewed', function(e) {
                            e.preventDefault();
                            e.stopPropagation();
                            
                            //console.log('Clearing all recently viewed products');
                            
                            // Clear the cookie and localStorage
                            cookie.destroy();
                            localStorage.removeItem('shopify_recently_viewed');
                            
                            // Hide the entire recently viewed section
                            recentlyViewed.fadeOut(300, function() {
                                recentlyViewed.hide();
                            });
                        });

                        // Add click event handler for remove buttons
                        productGrid.on('click', '.remove-recently-viewed', function(e) {
                            e.preventDefault();
                            e.stopPropagation();

                            var $card = $(this).closest('.card');
                            var $productElement = $(this).closest('.product');
                            var productHref = $card.find('a.card-title').attr('href');

                            //console.log('Card element:', $card[0]);
                            //console.log('Product href found:', productHref);

                            // Try different selectors to find the product link
                            if (!productHref) {
                                productHref = $card.find('a[href*="/products/"]').first().attr('href');
                                //console.log('Alternative product href found:', productHref);
                            }

                            if (!productHref) {
                                console.error('No product href found in card');
                                return;
                            }

                            var productHandle = productHref.replace('/products/', '');

                            //console.log('Product handle to remove (decoded):', productHandle);

                            // Try to remove both encoded and decoded versions
                            var encodedHandle = encodeURIComponent(productHandle);
                            //console.log('Product handle to remove (encoded):', encodedHandle);

                            // Remove from shopify_recently_viewed cookie and localStorage
                            cookie.remove(productHandle);
                            cookie.remove(encodedHandle);

                            // Console log updated values after removal
                            var updatedCookieValue = jQuery.cookie('shopify_recently_viewed');
                            var updatedLocalStorageValue = localStorage.getItem('shopify_recently_viewed');

                            //console.log('Updated cookie value after removal:', updatedCookieValue);
                            //console.log('Updated localStorage value after removal:', updatedLocalStorageValue);

                            // Always remove the slide visually, regardless of whether it was in the cookie
                            if ($productElement.length && productGrid.hasClass('swiper-initialized')) {
                                // Get the correct slide index using Swiper's data attribute
                                var slideIndex = Array.from(swiper.slides).indexOf($productElement[0]);
                                //console.log('Swiper slide index:', slideIndex);

                                if (slideIndex === -1) {
                                    console.error('Could not find slide index, falling back to manual removal');
                                    // Fallback to manual removal
                                    $productElement.fadeOut(300, function() {
                                        $(this).remove();
                                        updateRemoveButtonVisibility();
                                    });
                                    return;
                                }

                                //console.log('Using slide index:', slideIndex);

                                // Use Swiper's removeSlide method
                                swiper.removeSlide(slideIndex);

                                // Check remaining products after removal
                                setTimeout(function() {
                                    var remainingProducts = productGrid.find('.product').length;

                                    if (remainingProducts <= 0) {
                                        // Hide the entire recently viewed section if no products left
                                        recentlyViewed.hide();
                                    } else if (remainingProducts == 1) {
                                        // For single product, disable loop if enabled
                                        swiper.params.loop = false;
                                        swiper.update();
                                        updateRemoveButtonVisibility();
                                    } else {
                                        // Update slider after removal
                                        swiper.update();
                                        updateRemoveButtonVisibility();
                                    }
                                }, 50);
                            } else if ($productElement.length) {
                                // Fallback for non-slider case
                                $productElement.fadeOut(300, function() {
                                    $(this).remove();

                                    // Add a small delay to ensure DOM is updated before checking
                                    setTimeout(function() {
                                        // Check remaining products after removal
                                        var remainingProducts = productGrid.find('.product').length;

                                        if (remainingProducts <= 0) {
                                            // Hide the entire recently viewed section if no products left
                                            recentlyViewed.hide();
                                        } else {
                                            // Update remove button visibility for non-slider cases
                                            updateRemoveButtonVisibility();
                                        }
                                    }, 50);
                                });
                            }
                        });

                    }
                }

                if ($('body').hasClass('cursor-fixed__show')){
                    window.sharedFunctionsAnimation.onEnterButton();
                    window.sharedFunctionsAnimation.onLeaveButton();
                }
            }
        }
    };

    return {
        resizeImage: function (src, size) {
            if (size == null) {
                return src;
            }

            if (size == 'master') {
                return src.replace(/http(s)?:/, "");
            }

            var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);

            if (match != null) {
                var prefix = src.split(match[0]);
                var suffix = match[0];

                return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "")
            } else {
                return null;
            }
        },

        showRecentlyViewed: function (params) {
            var params = params || {};

            // Update defaults.
            jQuery.extend(config, params);

            // Read cookie.
            productHandleQueue = cookie.read();

            // Template and element where to insert.
            template = config.templateId;
            wrapper = jQuery('#' + config.wrapperId);

            // How many products to show.
            config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);

            // If we have any to show.
            if (config.howManyToShow && wrapper.length) {
                // Getting each product with an Ajax call and rendering it on the page.
                if (template == 'recently-viewed-product-popup') {
                    const wrapperP = wrapper;
                    moveAlong(wrapperP);
                } else {
                    const wrapperS = wrapper;
                    doAlong(wrapperS);
                }
            }
        },

        getConfig: function () {
            return config;
        },

        clearList: function () {
            cookie.destroy();
        },

        recordRecentlyViewed: function (params) {
            var params = params || {};

            // Update defaults.
            jQuery.extend(config, params);

            // Read cookie.
            var recentlyViewed = cookie.read();

            // If we are on a product page.
            if (window.location.pathname.indexOf('/products/') !== -1) {
                // What is the product handle on this page.
                var splitted = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/);
                if (splitted == null) {
                    var productHandle = decodeURIComponent(window.location.pathname.split('/products/')[1]);
                } else {
                    var productHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
                }
                // In what position is that product in memory.
                var position = jQuery.inArray(productHandle, recentlyViewed);
                // If not in memory.
                if (position === -1) {
                    // Add product at the start of the list.
                    recentlyViewed.unshift(productHandle);
                    // Only keep what we need.
                    recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
                } else {
                    // Remove the product and place it at start of list.
                    recentlyViewed.splice(position, 1);
                    recentlyViewed.unshift(productHandle);
                }

                // Update cookie.
                cookie.write(recentlyViewed);
            }
        }
    };
})();

/**
 * Recently Viewed Block Section - Uses jQuery viewportChecker with 100px offset
 * This loads the recently viewed products when the section is 100px away from viewport
 * Triggered from product-recently-viewed.liquid section
 */
(function($) {
    'use strict';
    
    function initRecentlyViewedBlockViewportChecker() {
        var $blocks = $('[data-recently-viewed-block]');
        
        if ($blocks.length === 0) return;
        
        $blocks.each(function() {
            var $block = $(this);
            var sectionId = $block.attr('sectionId');
            var config = window.recentlyViewedConfig && window.recentlyViewedConfig[sectionId];
            
            // Skip if no config or already loaded
            if (!config || $block.hasClass('ajax-loaded')) return;
            
            // Use viewportChecker with 100px offset
            $block.viewportChecker({
                offset: -500, // Load when 500px away from viewport
                repeat: false,
                callbackFunction: function(elem, action) {
                    console.log('viepoert checker recently viewed 500');

                    if (action === 'add' && !$block.hasClass('ajax-loaded')) {
                        $block.addClass('ajax-loaded');
                        
                        Shopify.Products.showRecentlyViewed({
                            howManyToShow: config.limit,
                            wrapperId: 'recently-viewed-products-list-2',
                            templateId: 'recently-viewed-product-block',
                            layout: config.layout,
                            swipe: config.swipe,
                            media: config.imageRatio,
                            onComplete: function() {
                                if (window.location.pathname.indexOf('/products/') !== -1) {
                                    $.cookie('shopify_recently_viewed', config.cookieValue, {
                                        expires: config.expireDay,
                                        path: '/',
                                        domain: window.location.hostname
                                    });
                                }
                            }
                        });
                    }
                }
            });
        });
    }
    
    // Initialize when DOM is ready and viewportChecker is available
    $(document).ready(function() {
        // Wait a short time for the liquid script to set up window.recentlyViewedConfig
        setTimeout(function() {
            if (typeof $.fn.viewportChecker === 'function') {
                initRecentlyViewedBlockViewportChecker();
            } else {
                // If viewportChecker not loaded yet, wait for it
                var checkInterval = setInterval(function() {
                    if (typeof $.fn.viewportChecker === 'function') {
                        clearInterval(checkInterval);
                        initRecentlyViewedBlockViewportChecker();
                    }
                }, 100);
                
                // Clear interval after 5 seconds to prevent infinite checking
                setTimeout(function() {
                    clearInterval(checkInterval);
                }, 5000);
            }
        }, 100);
    });
    
})(jQuery);
